import { ServiceShortName } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../machine/context';
import { ResolvedByThirdPartySelect } from '../resolved-by-third-party-select';
import { ResolvedByThirdPartyDocumentForm } from '../resolved-by-third-party-document-form';
import { ResolvedByThirdPartyDisclaimer } from '../components/resolved-by-third-party-disclaimer';
import { ResolvedByThirdPartyComplete } from '../components/resolved-by-third-party-complete';

export function ResolvedByThirdPartyScreen() {
    ReportedFindingsMachineContext.useActorRef();

    const isMinimumStandards = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.serviceShortName as ServiceShortName
            === ServiceShortName.MinimumStandards
    );

    const isThirdParty = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('selectThirdPartyItems')
    );

    const isThirdPartyResolutionForm = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('thirdPartyResolutionForm')
    );

    const isThirdPartySubmit = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('thirdPartyDisclaimer')
            || state.matches('submitResolution')
    );

    const isThirdPartyComplete = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('thirdPartyComplete')
    );

    return (
        <>
            {isThirdParty && (
                <ResolvedByThirdPartySelect />
            )}
            {(isThirdPartyResolutionForm || (isMinimumStandards && isThirdPartySubmit)) && (
                <ResolvedByThirdPartyDocumentForm
                    isSubmitting={isMinimumStandards && isThirdPartySubmit}
                />
            )}
            {(isThirdPartySubmit && !isMinimumStandards) && (
                <ResolvedByThirdPartyDisclaimer />
            )}
            {(isThirdPartyComplete) && (
                <ResolvedByThirdPartyComplete />
            )}
        </>
    );
}
